module.exports = __webpack_public_path__ + "media/images/icons/mapaDopravnichProuduW-648e6e93f33acc7c05ec72582a1fa2a3.svg";